/*
 * The Belgian Brewer: trade enquiry form (sections/tbb-trade.liquid).
 * Checks required answers before sending and puts the message next to the field.
 * Without this script the form still sends (Shopify checks the email itself).
 */
const emailPattern = /^\S+@\S+\.\S+$/;

function setUp(root) {
  if (root.dataset.tbbReady) return;
  root.dataset.tbbReady = 'true';

  const done = root.querySelector('[data-tbb-trade-done]');
  if (done) {
    done.scrollIntoView({ block: 'center' });
    done.focus({ preventScroll: true });
  }

  const form = root.querySelector('form');
  if (!form) return;

  const setMessage = (el, ok, text) => {
    el.setAttribute('aria-invalid', String(!ok));
    const message = document.getElementById(el.getAttribute('aria-describedby'));
    if (message) message.textContent = ok ? '' : text;
  };

  form.addEventListener('change', (event) => {
    const group = event.target.closest('[data-tbb-required-group]');
    if (group) setMessage(group, true, '');
  });

  form.addEventListener('submit', (event) => {
    let firstInvalid = null;

    form.querySelectorAll('[data-tbb-required]').forEach((field) => {
      const value = field.value.trim();
      const ok = field.type === 'email' ? emailPattern.test(value) : value !== '';
      setMessage(field, ok, field.dataset.tbbRequired);
      if (!ok && !firstInvalid) firstInvalid = field;
    });

    form.querySelectorAll('[data-tbb-required-group]').forEach((group) => {
      const ok = group.querySelector('input:checked') !== null;
      setMessage(group, ok, group.dataset.tbbRequiredGroup);
      if (!ok && !firstInvalid) firstInvalid = group.querySelector('input');
    });

    if (firstInvalid) {
      event.preventDefault();
      firstInvalid.focus();
    }
  });
}

const init = (root = document) => root.querySelectorAll('[data-tbb-trade]').forEach(setUp);
init();
document.addEventListener('shopify:section:load', (event) => init(event.target));
